/**
 * T103 — empresa (tenant) ativa no frontend.
 *
 * ApiClientStorage: `empresa` é o restaurante selecionado no login
 * (id/slug/nome/perfil). O cardápio público resolve o slug pela URL
 * (?restaurante=... no QR) e, na falta, cai na empresa ativa (fallback).
 *
 * `visitante` = operador da plataforma (role ADMIN global) entrou no
 * restaurante SEM vínculo ("Entrar" na área do operador) — poder emprestado.
 */
export interface EmpresaAtiva {
  id: string;
  slug: string;
  nome: string;
  logo?: string | null;
  perfil: string;
  visitante?: boolean;
}

const CHAVE = 'empresa';

export function salvarEmpresa(empresa: EmpresaAtiva | null) {
  if (empresa) {
    localStorage.setItem(CHAVE, JSON.stringify(empresa));
  } else {
    localStorage.removeItem(CHAVE);
  }
}

export function empresaAtiva(): EmpresaAtiva | null {
  try {
    const bruto = localStorage.getItem(CHAVE);
    return bruto ? (JSON.parse(bruto) as EmpresaAtiva) : null;
  } catch {
    return null;
  }
}

/** Slug do restaurante das chamadas PÚBLICAS (cardápio/QR). */
export function slugCardapio(): string | undefined {
  // 1) Query da URL (?restaurante=...) — cliente escaneou o QR
  const daUrl = new URLSearchParams(window.location.search).get('restaurante');
  if (daUrl) return daUrl;
  // 2) Empresa ativa (admin usando o painel)
  return empresaAtiva()?.slug;
}
